import { render } from "./BoxesDetail.vue?vue&type=template&id=bfbca152&scoped=true"
import script from "./BoxesDetail.vue?vue&type=script&lang=js"
export * from "./BoxesDetail.vue?vue&type=script&lang=js"

import "./BoxesDetail.vue?vue&type=style&index=0&id=bfbca152&lang=scss&scoped=true"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfbca152"]])

export default __exports__